import React from "react";

import FlippyMaster from "./LearnMoreSection/FlippyMaster";
import HowToRead from "./LearnMoreSection/HowItRead";
import HowToImprove from "./LearnMoreSection/HowToImprove";
import WhatItMeansSection from "./LearnMoreSection/WhatItMeans";
// import ExplorePrograms from "src/components/organisms/cgm/cgm-logs/ExplorePrograms";

interface LearnMoreSectionProps {
  content: any;
}

const LearnMoreSection: React.FC<LearnMoreSectionProps> = ({ content }) => {
  return (
    <div className="flex flex-col gap-4 py-4">
      {/* <FlippyMaster className="px-4" /> */}

      {content?.whatItMeansSection && (
        <WhatItMeansSection
          title={content?.whatItMeansSection?.title}
          description={content?.whatItMeansSection?.description}
        />
      )}

      {content?.howToReadSection && (
        <HowToRead
          title={content?.howToReadSection?.title}
          image={content?.howToReadSection?.image}
        />
      )}

      {/* <FlippyMaster variant="coach" className="px-4" /> */}

      {content?.howToImproveSection && (
        <HowToImprove
          title={content?.howToImproveSection?.title}
          sections={content?.howToImproveSection?.sections}
        />
      )}

      {/* <ExplorePrograms variant="small" /> */}
    </div>
  );
};

export default LearnMoreSection;
